{
  "min": 114,
  "max": 302,
  "R": [0, 255, 255],
  "G": [0, 129, 255],
  "B": [0, 0, 255],
  "A": [0, 88, 228],
  "I": [0, 103, 255]
}
